package com.essntl.features.proposal.ui.allproposal.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.resources.LocalRes
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.painterResource

@Composable
fun AddProposalPopup(
    isOpen: Boolean,
    onDismissRequest: () -> Unit,
    onAddProposal: () -> Unit,
    onSelectRequest: () -> Unit,
) {
    if (isOpen) {
        EsDialog(
            title = "Add proposal",
            onDismissRequest = onDismissRequest,
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(2.spacing),
                modifier = Modifier
                    .padding(
                        vertical = 4.spacing,
                        horizontal = 2.spacing,
                    ),
            ) {
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(.5f.spacing),
                    modifier = Modifier
                        .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
                        .pointerHoverIcon(PointerIcon.Hand)
                        .clickable {
                            onDismissRequest()
                            onAddProposal()
                        }
                        .background(MaterialTheme.esColorScheme.bgPrimary)
                        .padding(
                            horizontal = 2.spacing,
                            vertical = 1.spacing,
                        ),
                ) {
                    val res = LocalRes.current

                    Image(
                        painter = painterResource(res.addProposalImage),
                        contentDescription = "add image",
                        modifier = Modifier
                            .padding(
                                horizontal = 30.dp,
                                vertical = 3.spacing,
                            )
                            .width(140.dp)
                            .height(152.dp),
                    )

                    Text(
                        text = "From scratch",
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.s2SemiBold16,
                    )
                }

            }
        }
    }
}